module.exports = __webpack_public_path__ + "static/media/logo.ca5aa82b.jpg";